import { Flex, Radio } from "@theorgchartdev/storybook";
import * as React from "react";
import { appstr } from "@coreapp/utils/appstr";
import {
  enumFeaturesList,
  enumPositionDataIngestMode,
  enumPositionGenerationMode,
  enumUIModes
} from "@coreapp/constants";
import SectionPrompt from "@/appComponents/Blocks/Composites/SectionPrompt/SectionPrompt";
import { kAppendDisplayFieldMappingConnectors, GetAppendDisplayFields } from "./Utils";

export const PositionOptionsComposite = ({ config, importType, index, onChange }) => {
  // Get current dataType from config (default to "employees")
  const currentDataType = config?.dataType || "employees";

  const isPositionDataset = currentDataType === "positions";
  const isEmployeeDataset = currentDataType === "employees";

  // Initialize dataType if it's not set
  React.useEffect(() => {
    if (!config?.dataType) {
      const updatedConfig = {
        ...config,
        dataType: "employees"
      };

      onChange(updatedConfig, index);
    }
  }, [config, index, onChange]);

  const handleDatasetChange = isPositions => {
    const updatedConfig = {
      ...config,
      dataType: isPositions ? "positions" : "employees"
    };

    // Clear old field mappings when switching dataset types
    if (updatedConfig.map) {
      const cleanedMap = { ...updatedConfig.map };

      if (isPositions) {
        // Switching to position dataset - remove employee field mappings
        delete cleanedMap["EmployeeID"];
        delete cleanedMap["Employee SupervisorID"];
      } else {
        // Switching to employee dataset - remove position field mappings
        delete cleanedMap["PositionID"];
        delete cleanedMap["Parent PositionID"];
      }

      if (kAppendDisplayFieldMappingConnectors.includes(config?.source)) {
        GetAppendDisplayFields(isPositions ? "employees" : "positions").forEach(
          field => delete cleanedMap[field]
        );
      }

      updatedConfig.map = cleanedMap;
    }

    onChange(updatedConfig, index);
  };

  return (
    <Flex key={index} direction={"column"} gap={"12px"}>
      <SectionPrompt
        title={appstr("What type of dataset do you want to ") + importType + "?"}
        require
      >
        <Flex direction={"column"} gap={"8px"}>
          <Radio
            key={0}
            data-testid={"employee-dataset-radio"}
            id={"employee-dataset-radio"}
            label={appstr("Employee dataset")}
            value="employee"
            checked={isEmployeeDataset}
            onChange={() => handleDatasetChange(false)}
          />
          <Radio
            key={1}
            data-testid={"position-dataset-radio"}
            id={"position-dataset-radio"}
            label={appstr("Position dataset")}
            value="position"
            checked={isPositionDataset}
            onChange={() => handleDatasetChange(true)}
          />
        </Flex>
      </SectionPrompt>
    </Flex>
  );
};
